import React, { Component, useEffect, useState } from 'react';
// import endpoint_code_cases from './../data/2022-12/endpoint_code_cases__FG_pheno-r10_geno-r9__2022-12-16.json';
import endpoint_code_cases from './../data/2023-05/endpoint_code_cases__FG_pheno-r11_geno-r10__2023-05-17.json';
import code_longnames from './../data/2022-11/code_longnames.json';
import Overview from './heatmap/overview'
import * as d3 from "d3";

function Heatmap (props) {

    const endpoints = props.endpoints
    const setEndpoints = props.setEndpoints
    const blocks = props.blocks
    const format = props.format
    const color = props.color
    const updateURL = props.updateURL

    const [focus, setFocus] = useState('ratio')
    const [unit, setUnit] = useState(Math.floor((window.innerWidth - 34 - endpoints.length) / (endpoints.length + 1)))

    const alert_inaccurate = ". POSSIBLY INACCURATE IN COMPLEX ENDPOINTS!"
    const alert_definition = ". Not used in endpoint definition"

    function formatCount (cases) {
        if (cases === null) return undefined
        else if (cases !== cases) return undefined
        else return format.count(cases)
    }

    function formatRatio (ratio) {
        if (ratio === null) return undefined
        else if (ratio !== ratio) return undefined
        else if (ratio === 0) return undefined
        else return Math.round(ratio*100)+'%'
    }

    function formatCodeLongname (longname) {
        if (longname === undefined) return 'Name not found'
        else return longname.replace(alert_inaccurate, ' ⊙').replace(alert_definition, ' ∅')
    }

    function getContentHeight () {
        const header = document.getElementById('m_header').getBoundingClientRect().height
        return props.contentHeight - header - 62
    }

    function getData (endpoints) {

        function top10(endpoint) {
            let codes = {};
            if (endpoint in endpoint_code_cases) codes = endpoint_code_cases[endpoint];
            
            const top = Object.entries(codes)
              .sort((a,b) => (parseInt(b[1]) - parseInt(a[1])))
              .map(rec => rec[0])
              .slice(0, 10);
            return top
        }

        // Gather top 10 codes for the given endpoints
        let row_codes = [];
        for (let endpoint of endpoints) {
          let top10_codes = top10(endpoint.code);
          for (let code of top10_codes) {
            if (!row_codes.includes(code)) row_codes.push(code)
          }
        }
        

        let rows = [];
        row_codes.forEach(row_code => {
          let cells = []
          endpoints.forEach(endpoint => {
            let cases = null;
            if ((endpoint.code in endpoint_code_cases) && (row_code in endpoint_code_cases[endpoint.code])){
              cases = Number(endpoint_code_cases[endpoint.code][row_code]);
            }
            cells.push({
              row_code: row_code,
              row_longname: code_longnames[row_code],
              col_code: endpoint.code,
              col_longname: endpoint.longname,
              col_cases: endpoint.cases,
              cases: cases,
              ratio: cases/endpoint.cases
            });
          })
          rows.push(cells)
        })
        return rows
    }

    function colorHeatmap(cases, ratio) {
        if (focus === undefined || focus === "ratio") {
            if (ratio === 0 || ratio === null || ratio !== ratio || ratio === undefined) return color.lightgray
            else return m_color_ratio(ratio)
        }
        else if (focus === "cases") {
            if (cases === null || cases !== cases || cases === undefined) return color.lightgray
            else return m_color_cases(cases)
        }
    }

    function updateEndpoints (endpoint) {
        setEndpoints(endpoint)
        setUnit(Math.floor((window.innerWidth - 34 - endpoints.length) / (endpoints.length)))
    }

    const data = getData(endpoints)
    const maxCases = d3.max(d3.merge(data).map(el => Number(el.cases)))
    const m_color_cases = d3.scaleLinear().domain([0, maxCases]).range([color.lightpurple, color.violet]).clamp(true)
    const m_color_ratio = d3.scaleLinear().domain([0, 1]).range([color.lightpurple, color.violet]).clamp(true)

    updateURL('heatmap', endpoints.map(el => el.code))

    useEffect(()=> {

        window.addEventListener("resize", function () {setUnit(Math.floor((window.innerWidth - 34 - endpoints.length) / (endpoints.length + 1)))})

        d3.selectAll('.m_col').style('width', unit-34+'px')

        d3.select('#m_legend').style('width', unit-10+'px')
        d3.select('#m_content').style('height', getContentHeight()+'px')
        d3.select('#m_header').selectAll('.m_col').data(endpoints).join(
            function(enter){
                const column = enter.append('div')
                    .attr('id', (d,i) => 'm_col'+i)
                    .attr('class', 'm_col')
                    .style('width', unit-34+'px')
                
                const div = column.append('div')
                    .style('width', '100%')
                    .style('display', 'flex')
                    .style('justify-content', 'space-between')

                const header = div.append('div')
                
                header.append('p')
                    .attr('class', 'm_endpoint_longname')
                    .html(d => d.longname)

                header.append('p')
                    .attr('class', 'm_endpoint_name')
                    .html(d => format.name(d.code))
                
                div.append('p')
                    .attr('class', 'm_endpoint_remove')
                    .html('×')
                    .on('click', (e,d) => updateEndpoints(d.code))

                column.append('p')
                    .attr('class', 'm_endpoint_cases m_info')
                    .style('font_size', '10px')
                    .style('color', color.gray)
                    .html(d => 'Cases: <strong>' + format.count(d.cases) + '</strong>')
            },
            function(update){
                update.style('width', unit-34+'px').attr('id', (d,i) => 'm_col'+i)
                update.select('.m_endpoint_longname').html(d => d.longname)
                update.select('.m_endpoint_name').html(d => format.name(d.code))
                update.select('.m_endpoint_cases').html(d => 'Cases: <strong>' + format.count(d.cases) + '</strong>')
                update.select('.m_endpoint_remove').on('click', (e,d) => updateEndpoints(d.code))
            }
        )
    
        d3.select('#m_codes').style('width', unit+'px').selectAll('.m_code').data(data).join(
            function(enter){
                const code = enter.append('div')
                    .attr('id', (d,i) => 'm_code_'+i)
                    .attr('class', 'm_code')
                
                code.append('p')
                    .attr('class', 'm_code_longname')
                    .html(d => formatCodeLongname(d[0].row_longname))

                code.append('p')
                    .attr('class', 'm_code_name')
                    .html(d => format.name(d[0].row_code))
            },
            function(update){
                update.attr('id', (d,i) => 'm_code_'+i)
                update.select('.m_code_longname').html(d => formatCodeLongname(d[0].row_longname))
                update.select('.m_code_name').html(d => format.name(d[0].row_code))
            }
        )
    
        d3.select('#m_cells').style('width', unit*endpoints.length+'px').selectAll('.m_cell').data(d3.merge(data)).join(
            function(enter){
                const cell = enter.append('div')
                    .attr('id', (d,i) => 'm_cell_'+i)
                    .attr('class', 'm_cell')
                    .style('width', unit-1+'px')
                    .style('background-color', d => colorHeatmap(d.cases, d.ratio))
                
                cell.append('p')
                    .attr('class', 'm_info m_cell_cases')
                    .html(d => formatCount(d.cases))

                cell.append('p')
                    .attr('class', 'm_info m_cell_ratio')
                    .html(d => formatRatio(d.ratio))
            },
            function(update){
                update.style('width', unit-1+'px')
                    .attr('id', (d,i) => 'm_cell_'+i)
                    .style('background-color', d => colorHeatmap(d.cases, d.ratio))
                    .on('mouseenter', function (e,d){
                        const cell = +d3.select(this).attr('id').replace('m_cell_','')
                        const row = Math.floor(cell/endpoints.length)
                        const col = Math.floor(cell-row*endpoints.length)
                        d3.select('#m_code_'+row).classed('m_highcode', true)
                        for (let i=0; i < endpoints.length; i++) {
                            const index = row*endpoints.length+i
                            d3.select('#m_cell_'+index).classed('m_highcell', true)
                            d3.select('#o_cell_'+index).classed('o_highcell', true)
                        }
                    })
                    .on('mouseleave', function (e,d){
                        const cell = +d3.select(this).attr('id').replace('m_cell_','')
                        const row = Math.floor(cell/endpoints.length)
                        const col = Math.floor(cell-row*endpoints.length)
                        d3.select('#m_code_'+row).classed('m_highcode', false)
                        for (let i=0; i < endpoints.length; i++) {
                            const index = row*endpoints.length+i
                            d3.select('#m_cell_'+index).classed('m_highcell', false)
                            d3.select('#o_cell_'+index).classed('o_highcell', false)
                        }
                    })
                update.select('.m_cell_cases').html(d => formatCount(d.cases))
                update.select('.m_cell_ratio').html(d => formatRatio(d.ratio))
            }
        )

    })


    return (
        <div id='heatmap'>
            <div>
                <div id="m_title">
                <div className="title_inner">
                    <h1>Overlap heatmap</h1>
                </div>
                <div className="title_inner">
                    <button 
                        id="m_color_ratio_btn"
                        className={focus === 'ratio' ? "dark_btn active_btn" : 'dark_btn'}
                        onClick={()=>setFocus('ratio')}
                        >
                        Overlap ratio
                    </button>
                    <button
                        id="m_color_cases_btn"
                        style={{margin: '0 10px 0 10px'}}
                        className={focus === 'cases' ? "dark_btn active_btn" : 'dark_btn'}
                        onClick={()=>setFocus('cases')}
                        >
                        Overlapping cases
                    </button>
                </div>
                </div>
                <div id="m_header">
                    <div id="m_legend">
                        <h5>Overlapping cases between the selected endpoints and their top definition codes in FinnGen datasets.</h5>
                        <h5 style={{margin: '8px 0 0 0'}}>∅ &#x2000; Not used in endpoint definition</h5>
                        <h5>⊙ &#x2000; Possibly inaccurate in complex endpoints</h5>
                    </div>
                </div>
                <div id="m_content">
                    <div id="m_codes"></div>
                    <div id="m_cells"></div>
                </div>
            </div>
            {data.length > 18 && (
                <Overview 
                    endpoints={endpoints}
                    cells={data}
                    colorHeatmap={colorHeatmap}
                />
            )}
        </div>
    )
}

export default Heatmap;